
import { defineComponent } from "vue";
import axios from "axios";
import { store } from "@/store";
import { onBoardingSaveDesignRef } from "@/onboarding/Refs";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "SaveAndLoginWrap",
  setup() {
    const isUserLoggedIn = async () => {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/editor/customers/ajax.php?mode=isUserLoggedIn`
        );
        const logged = res.data.logged as boolean;

        if (logged) {
          store.dispatch(ActionTypes.SET_MODAL, "saveLabel");
        } else {
          store.dispatch(ActionTypes.SET_MODAL, "loginModal");
        }
      } catch (e) {
        console.log(e);
      }
    };

    return {
      onBoardingSaveDesignRef,
      isUserLoggedIn,
    };
  },
});
